import React, { useState } from "react";

import { makeStyles } from "tss-react/mui";
import { Button, Grid, Skeleton, Typography } from "@mui/material";
import { ptBR } from "date-fns/locale";

import {
  DatePickerModal,
  DatePickerModalProps,
} from "../MUIExtensions/DatePickerModal";

const useStyles = makeStyles()((theme) => ({
  outer: {
    padding: theme.spacing(1, 0),
  },
  dateStyles: {
    textTransform: "lowercase",
    "&::first-letter": {
      textTransform: "capitalize",
    },
  },
}));

export const SelectorMonthYear = ({
  referenceDate,
  onDatechange,
  yearOnly = false,
  customDisplayText = "",
}: SelectorMonthYearProps) => {
  const { classes } = useStyles();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const handleButtonPress = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const formatDisplayDate = (date: Date) => {
    if (yearOnly) {
      return `Ano de ${date.toLocaleDateString(ptBR.code, {
        year: "numeric",
      })}`;
    } else {
      return date.toLocaleDateString(ptBR.code, {
        month: "long",
        year: "numeric",
      });
    }
  };

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      className={classes.outer}
    >
      <Typography
        variant="h3"
        color="text.primary"
        className={classes.dateStyles}
      >
        {customDisplayText}
        {!customDisplayText &&
          referenceDate &&
          formatDisplayDate(referenceDate)}
        {!customDisplayText && !formatDisplayDate && <Skeleton />}
      </Typography>

      <Button color="secondary" variant="outlined" onClick={handleButtonPress}>
        <Typography variant="caption">
          {`Alterar ${yearOnly ? "ano" : "mês"}`}
        </Typography>
      </Button>

      <DatePickerModal
        referenceDate={referenceDate}
        open={isModalOpen}
        onClose={handleModalClose}
        onDateChange={onDatechange}
        yearOnly={yearOnly}
      />
    </Grid>
  );
};

export type SelectorMonthYearProps = {
  /* Date with month and year that will be displayed by the component */
  referenceDate: DatePickerModalProps["referenceDate"];
  /* Handler for when the user saves the changes */
  onDatechange: DatePickerModalProps["onDateChange"];
  /* Only allow user to pick a year, not month */
  yearOnly?: DatePickerModalProps["yearOnly"];
  /* Text to be displayed instead of the parsed date */
  customDisplayText?: string;
};
